module.exports = __webpack_public_path__ + "img/developer.0b3d09a2.svg";